var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Dialog, Typography, Divider, Button, Box, Stack, CircularProgress, } from '@mui/material';
import UploadListItem from './UploadListItem';
import UploadDragAndDrop from '../../UploadDragAndDrop';
const UploadModal = ({ open, onClose, brief, onSubmit, onDeleteFile, isSubmitting, isSubmitted = false, }) => {
    const [files, setFiles] = useState([]);
    const [deleteFileId, setDeleteFileId] = useState('');
    const onFileUpload = (file) => {
        setFiles((prevState) => [...prevState, file]);
    };
    const handleDeleteUploads = (idx) => {
        let filesCopy = [...files];
        filesCopy.splice(idx, 1);
        setFiles(filesCopy);
    };
    const handleSubmit = () => __awaiter(void 0, void 0, void 0, function* () {
        const formData = new FormData();
        Array.from(files).forEach((file) => {
            formData.append('files', file, file === null || file === void 0 ? void 0 : file.name);
        });
        onSubmit(formData);
    });
    const deleteUploadedFile = (fileId) => {
        setDeleteFileId(fileId);
        onDeleteFile(fileId);
    };
    useEffect(() => {
        if (isSubmitted && !isSubmitting) {
            setFiles([]);
        }
    }, [isSubmitted]);
    return (_jsx(Dialog, Object.assign({ open: open, onClose: onClose, fullWidth: true, keepMounted: true, maxWidth: "md", PaperProps: {
            sx: {
                overflow: 'hidden',
                borderRadius: '12px',
                padding: '30px',
                height: 'fit-content',
                width: '90%',
                '@media (max-width: 960px)': {
                    height: 'auto',
                },
            },
        } }, { children: _jsxs(Box, { children: [_jsx(Typography, Object.assign({ variant: "h3" }, { children: "Upload your Plan" })), _jsx(Typography, Object.assign({ variant: "subtitle2", mt: "10px" }, { children: "If you have an existing media brief, share it with us here." })), _jsx(Divider, { sx: { width: '100%', margin: '20px 0px' } }), _jsxs(Stack, Object.assign({ direction: "row", sx: { width: '100%', minHeight: '350px' } }, { children: [_jsxs(Stack, Object.assign({ sx: { flexGrow: 1, margin: '0px 10px', width: '40%' } }, { children: [_jsx(UploadDragAndDrop, { onChange: onFileUpload, supportedFormats: ['pdf', 'xlsx'], maxFileSize: "1.5GB" }), _jsx(Typography, Object.assign({ variant: "subtitle2", color: "text.dark", fontWeight: 600, mb: '12px', mt: 3 }, { children: "Selected Files" })), _jsx(Divider, {}), _jsx(Box, Object.assign({ sx: { maxHeight: '350px', overflow: 'auto' } }, { children: files &&
                                        Array.from(files).map((file, index) => (_jsx(UploadListItem, { file: file, onDelete: () => handleDeleteUploads(index) }, index.toString()))) }))] })), _jsx(Divider, { orientation: "vertical", flexItem: true, sx: { marginTop: 3 } }), _jsxs(Stack, Object.assign({ sx: { flexGrow: 1, margin: '0px 10px', width: '52%' } }, { children: [_jsx(Typography, Object.assign({ variant: "subtitle2", color: "text.dark", fontWeight: 600, mb: '12px' }, { children: "Uploaded Files" })), _jsx(Divider, {}), _jsx(Box, Object.assign({ sx: { maxHeight: '350px', overflow: 'auto' } }, { children: (brief === null || brief === void 0 ? void 0 : brief.files) &&
                                        (brief === null || brief === void 0 ? void 0 : brief.files.map((file, index) => (_jsx(UploadListItem, { file: file, onDelete: () => deleteUploadedFile(file === null || file === void 0 ? void 0 : file._id), isLoading: deleteFileId === (file === null || file === void 0 ? void 0 : file._id) }, index.toString())))) }))] }))] })), _jsx(Stack, Object.assign({ direction: "row", justifyContent: "flex-end" }, { children: _jsx(Button, Object.assign({ variant: "contained", sx: {
                            marginTop: '4px',
                            width: '260px',
                            height: '40px',
                        }, endIcon: isSubmitting && _jsx(CircularProgress, { size: 18 }), disabled: !files.length || isSubmitting, onClick: handleSubmit }, { children: "Submit" })) }))] }) })));
};
export default UploadModal;
